export default __webpack_public_path__ + "static/media/nrw_dark.531bdd2a.png";